module.exports = __webpack_public_path__ + "static/dark-logo-21-86510b0d4d4f7f4a5f0b952c8803acfc.png";